// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Schließen',
  error: () => 'Fehler',
  warn: () => 'Warnung',
  info: () => 'Info',
  confirmation: () => 'Bestätigung',
  progressIndeterminate: () => 'Wird ausgeführt',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Zwischen ' + p['FROM_SECTION'] + ' und ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Kein übereinstimmender Abschnitt gefunden.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Drücken Sie die Eingabetaste, um einen Wert auszuwählen.',
  indexer_touchInstructionText: () =>
    'Doppeltippen und halten, um den Gestenmodus aufzurufen, und anschließend nach oben oder unten ziehen, um den Wert anzupassen.',
  inputPassword_show: () => 'Kennwort anzeigen',
  inputPassword_hide: () => 'Kennwort ausblenden',
  inputPassword_hidden: () => 'Kennwort ausgeblendet',
  formControl_clear: () => 'Leeren',
  formControl_loading: () => 'Wird geladen',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximale Länge ' + p['MAX_LENGTH'] + ' überschritten.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' Zeichen übrig.',
  formControl_requiredMessageDetail: () => 'Geben Sie einen Wert ein.',
  select_requiredMessageDetail: () => 'Wählen Sie einen Wert.',
  select_noMatchesFound: () => 'Keine Übereinstimmungen gefunden.',
  select_oneMatchFound: () => 'Eine Übereinstimmung gefunden',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' Übereinstimmungen gefunden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' oder mehr Übereinstimmungen gefunden',
  selectMultiple_selectedValues: () => 'Ausgewählte Werte',
  selectMultiple_showSelectedValues: () => 'Nur ausgewählte Werte anzeigen.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' Werte ausgewählt.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Drücken Sie die Rücktaste oder ENTF, um den ausgewählten Wert zu entfernen.',
  selectMultiple_apply: () => 'Anwenden',
  selectMultiple_back: () => 'Zurück',
  selector_selected: () => 'Kontrollkästchen aktiviert',
  selector_unselected: () => 'Kontrollkästchen nicht aktiviert',
  userAssistance_learnMore: () => 'Weitere Informationen',
  userAssistance_required: () => 'Erforderlich',
  filePicker_singleFileUploadError: () => 'Laden Sie jeweils nur eine Datei hoch',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Sie können keine Dateien des Typs ' + p['fileType'] + ' hochladen',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Sie können keine Dateien des folgenden Typs hochladen: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'unbekannt',
  filePicker_dropzonePrimaryText: () => 'Drag-and-Drop',
  filePicker_dropzoneSecondaryText: () => 'Datei auswählen oder hier ablegen',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dateien auswählen oder hier ablegen',
  filePicker_addFiles: () => 'Dateien hinzufügen',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Erhöhen',
  inputNumber_decrease: () => 'Verringern',
  inputNumber_converterParseError: () => 'Geben Sie eine Zahl ein.',
  noData_message: () => 'Keine anzuzeigenden Elemente',
  message_navigationFromMessagesRegion: () =>
    'Meldungsbereich wird geöffnet. Drücken Sie F6, um zum vorherigen fokussierten Element zurückzukehren.',
  message_navigationToMessagesRegion: () =>
    'Meldungsbereich enthält neue Meldungen. Drücken Sie F6, um zum aktuellen Meldungsbereich zu navigieren.',
  messageToast_allMessagesClosed: () => 'Alle Popup-Nachrichten sind geschlossen.',
  expandableList_groupCollapse: () => 'Ausgeblendet',
  expandableList_groupExpand: () => 'Eingeblendet',
  expandableList_expandCollapseInstructionText: () =>
    'Pfeiltasten zum Ein- und Ausblenden verwenden',
  list_suggestion: () => 'Vorschlag',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Schritt ' + p['currentStep'] + ' von ' + p['numberOfSteps'],
  train_current: () => 'Aktuell',
  train_visited: () => 'Besucht',
  train_not_visited: () => 'Nicht besucht',
  train_message_type: () => 'Meldungstyp',
  viz_drillable: () => 'Drillfähig',
  dataVisualization_stateSelected: () => 'Ausgewählt',
  dataVisualization_stateUnselected: () => 'Auswahl aufgehoben',
  dataVisualization_noData: () => 'Keine anzuzeigenden Daten'
};
export default bundle;
